<template>
  <v-sheet
    tile
    class="transparent d-flex align-self-stretch align-center"
  >
    <v-menu
      v-model="menuOpen"
      offset-y
      content-class="elevation-5"
      z-index="999"
      :close-on-content-click="false"
    >
      <template #activator="{ on, attrs, value }">
        <slot
          :listeners="on"
          :attributes="attrs"
          :open="value"
        />
      </template>

      <v-list>
        <template v-if="showCompanyScopeOption">
          <CompanyScope
            ref="companyScope"
            :company-scope="companyScope"
            menu-item
            class="avatar-menu-company-scope__control"
            @request-open="openCompanyScopeDialog"
          />

          <v-divider v-if="userMenu.length" />
        </template>

        <span
          v-for="(menu, i) in userMenu"
          :key="`user-menu-option-${i + 1}`"
        >
          <v-divider v-if="checkForDivider(menu, 'before')" />

          <component
            :is="menu.type_component"
            :menu="menu"
          />

          <v-divider v-if="checkForDivider(menu,'after')" />
        </span>
      </v-list>
    </v-menu>
  </v-sheet>
</template>

<script>
import ActionOption from './ActionOption'
import SelectOption from './SelectOption'
import LinkOption from './LinkOption'
import ModalOption from './ModalOption'
import ExternalLinkOption from './ExternalLinkOption'
import CompanyScope from '@/modules/base-module/company-scope/components/CompanyScope'
import helperMixin from '@/global/mixins/helperMixin'

export default {
  name: 'AvatarMenu',

  components: {
    CompanyScope,
    SelectOption,
    ActionOption,
    ModalOption,
    LinkOption,
    ExternalLinkOption
  },

  mixins: [
    helperMixin
  ],

  props: {
    companyScope: {
      type: Object,
      default: () => ({})
    },

    userMenu: {
      type: Array,
      default: () => ([])
    }
  },

  data () {
    return {
      menuOpen: false
    }
  },

  computed: {
    showCompanyScopeOption () {
      return this.isMobile && !!(this.companyScope && Object.keys(this.companyScope).length > 0)
    }
  },

  methods: {
    openCompanyScopeDialog () {
      this.menuOpen = false

      this.$nextTick(() => {
        if (this.$refs.companyScope && typeof this.$refs.companyScope.openCompanyScopeDialog === 'function') {
          this.$refs.companyScope.openCompanyScopeDialog()
        }
      })
    },

    checkForDivider (menu, where) {
      return 'dividers' in menu && menu.dividers.includes(where)
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .avatar-menu-company-scope__control {
    width: 100%;
  }

  .avatar-menu-company-scope__control .company-scope-menu-item {
    min-height: 48px;
  }

  .avatar-menu-company-scope__control .v-list-item__icon {
    margin-right: 12px;
  }
}
</style>
